<template>
  <div class="pos-layout" :class="{ 'inventory-mode': selectedNav === 'inventory' }">
    <!-- 左侧导航区 -->
    <aside class="sidebar">
      <!-- 顶部信息栏 -->
      <div class="sidebar-header">
        <!-- 打印机选择器 -->
        <div class="printer-selector">
          <label class="printer-label">
            <img src="/img/dyj.png" alt="打印机" class="printer-icon">
             
          </label>
          <select
            v-model="selectedPrinter"
            class="printer-select"
            @change="handlePrinterChange"
            :disabled="isLoadingPrinters"
          >
            <option value="" v-if="isLoadingPrinters">加载中...</option>
            <option value="" v-else>请选择打印机</option>
            <option
              v-for="printer in availablePrinters"
              :key="printer.id"
              :value="printer.id"
            >
              {{ printer.name }}{{ printer.isDefault ? ' (默认)' : '' }}
            </option>
          </select>
          <button
            class="refresh-printers-btn"
            @click="refreshPrinters"
            :disabled="isLoadingPrinters"
            title="刷新打印机列表"
          >
            <img
              src="/img/refresh.png"
              alt="刷新"
              class="refresh-icon"
              :class="{ 'spinning': isLoadingPrinters }"
            >
          </button>
          </div>

        <div class="login-info">
          <div class="user-info">
            <img src="/img/shouyinyuan.png" alt="收银员" class="info-icon">
            {{ displayName }}
          </div>
          <div class="shop-info">
            <img src="/img/dianpu.png" alt="店铺" class="info-icon">
            {{ shopName }}
          </div>
        </div>
      </div>

      <!-- 功能按钮组 -->
      <div class="nav-buttons">
        <div
          :class="['nav-item', { active: selectedNav === 'cashier' }]"
          @click="selectNav('cashier')"
        >
          <img src="/img/shouyintai.png" alt="收银" class="nav-icon">
          <span class="nav-text">收银</span>
        </div>
        <div
          :class="['nav-item', { active: selectedNav === 'orders' }]"
          @click="selectNav('orders')"
        >
          <img src="/img/quanbudingdan.png" alt="收银订单" class="nav-icon">
          <span class="nav-text">收银订单</span>
        </div>
        <div
          :class="['nav-item', { active: selectedNav === 'members' }]"
          @click="selectNav('members')"
        >
          <div class="nav-icon-text">会</div>
          <span class="nav-text">会员</span>
        </div>
        <div
          :class="['nav-item', { active: selectedNav === 'inventory' }]"
          @click="selectNav('inventory')"
        >
          <img src="/img/kucun-.png" alt="库存查询" class="nav-icon">
          <span class="nav-text">库存查询</span>
        </div>

        <div class="nav-item" @click="logout">
          <img src="/img/tuichu.png" alt="退出" class="nav-icon">
          <span class="nav-text">退出</span>
        </div>
      </div>
    </aside>

    <!-- 中间商品选择区 -->
    <main class="product-selection" v-if="selectedNav === 'cashier'">
      <!-- 区域标题和搜索 -->
      <div class="section-header">
        <h2 class="section-title">选择商品</h2>
        <div class="search-bar">
          <input
            v-model="searchKeyword"
            type="text"
            placeholder="搜索商品名称或条码..."
            class="search-input"
            @keyup.enter="handleSearch"
          />
          <button class="search-button" @click="handleSearch">搜索</button>
          <button
            class="refresh-products-btn"
            @click="refreshProducts"
            :disabled="isLoadingProducts"
            title="刷新商品列表"
          >
            <img
              src="/img/refresh.png"
              alt="刷新"
              class="refresh-icon"
              :class="{ 'spinning': isLoadingProducts }"
            >
          </button>
        </div>
      </div>

      <!-- 分类标签 -->
      <div class="category-tabs">
        <div
          v-for="category in categories"
          :key="category.id"
          :class="['category-tab', { active: selectedCategory === category.id }]"
          @click="selectCategory(category.id)"
        >
          <span class="category-name">{{ category.name }}</span>
        </div>

        <!-- 赠品筛选checkbox - 临时显示用于调试 -->
        <div class="gift-filter-tab">
          <label class="gift-filter-label">
            <input
              v-model="showOnlyGifts"
              type="checkbox"
              class="gift-filter-checkbox"
            />
            赠品
          </label>
        </div>
      </div>

      <!-- 商品网格 -->
      <div class="products-grid">
        <div
          v-for="product in filteredProducts"
          :key="product.id"
          class="product-card"
          @click="addToCart(product)"
        >
          <div class="product-category">{{ product.category?.title }}</div>
          <div class="product-image">
              <img v-if="product.cover_image" :src="product.cover_image" :alt="product.name" />
          </div>
          <div class="product-info">
            <div class="product-name">{{ product.name }}</div>
            <div class="product-stock">
              库存: {{ showOnlyGifts ? product.gift_quantity : product.quantity }}
            </div>
            <div class="product-price">
              <span v-if="showOnlyGifts" class="gift-price">赠品</span>
              <span v-else>¥{{ (product.price / 100).toFixed(2) }}</span>
            </div>
          </div>
          <div class="add-button">+</div>
        </div>
      </div>

          </main>

    <!-- 库存管理组件 -->
    <InventoryView
      v-if="selectedNav === 'inventory'"
      :userInfo="userInfo"
    />

    <!-- 订单管理组件 -->
    <OrdersView
      v-if="selectedNav === 'orders'"
      :userInfo="userInfo"
    />

    <!-- 会员管理组件 -->
    <MembersView
      v-if="selectedNav === 'members'"
      :userInfo="userInfo"
    />

    <!-- 右侧结算操作区 - 只在收银模式下显示 -->
    <template v-if="selectedNav === 'cashier'">
      <aside class="checkout-panel">
        <!-- 会员入口 -->
        <div class="member-section">
          <button
            class="member-button"
            @click="openMemberSelector"
          >
            {{ selectedMember ? selectedMember.name : '+ 选择会员' }}
          </button>
        </div>

        <!-- 已选商品列表 -->
        <div class="cart-list">
          <h3 class="cart-title">已选商品</h3>
          <div class="cart-items">
            <div v-if="displayCartItems.length === 0" class="cart-empty">
              暂无商品
            </div>
            <div v-for="item in displayCartItems" :key="item.cartItemKey" class="cart-item">
              <div class="cart-item-main">
                <div class="cart-item-name">{{ item.name }}</div>
              </div>
              <div class="cart-item-bottom">
                <div class="cart-item-price">
                  <span v-if="item.is_gift === 1" class="gift-price">赠品</span>
                  <span v-else>¥{{ item.price.toFixed(2) }}</span>
                </div>
                <div class="cart-item-quantity">
                  <button @click="decreaseQuantity(item)" class="quantity-btn">-</button>
                  <input
                    type="number"
                    v-model="item.quantity"
                    @input="validateQuantity(item)"
                    @blur="validateQuantity(item)"
                    class="quantity-input"
                    min="1"
                  />
                  <button @click="increaseQuantity(item)" class="quantity-btn">+</button>
                </div>
                <div class="cart-item-subtotal">
                  <span v-if="item.is_gift === 1" class="gift-price">赠品</span>
                  <span v-else>¥{{ (item.price * item.quantity).toFixed(2) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 底部结算区域 -->
        <div class="checkout-bottom">
          <!-- 金额展示区 -->
          <div class="amount-display">
            <div class="payment-top-row">
              <div class="total-amount">
                应收 <span class="amount">{{ totalAmount.toFixed(2) }}</span> 元
              </div>
              <div class="zero-amount">
                抹零：<span class="amount">¥{{ Math.abs(changeAmount).toFixed(2) }}</span>
              </div>
            </div>

            <div class="payment-details">
              <div class="payment-row">
                <div class="payment-left">
                  <span>实收：</span>
                  <span class="amount">¥{{ paidAmount.toFixed(2) }}</span>
                </div>
                <div class="payment-right">
                  <button
                    v-if="canZeroAmount"
                    class="modify-amount-btn"
                    @click="openAmountModifyDialog"
                  >
                    修改
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- 结账按钮 -->
          <div class="checkout-action">
            <button class="checkout-button" @click="handleCheckout">结账</button>
          </div>
        </div>
      </aside>
    </template>

    <!-- 会员选择弹窗 -->
    <MemberSelector
      :visible="showMemberSelector"
      @close="closeMemberSelector"
      @select="handleMemberSelected"
    />

    <!-- 交易成功提示框 -->
    <TransactionSuccessDialog
      :visible="showTransactionSuccess"
      :orderInfo="transactionOrderInfo"
      @confirm="handleTransactionConfirm"
      @print="handlePrintReceipt"
    />

    <!-- 实收金额修改弹窗 -->
    <div v-if="showAmountModifyDialog" class="amount-modify-overlay" @click="closeAmountModifyDialog">
      <div class="amount-modify-dialog" @click.stop>
        <div class="dialog-header">
          <h3>修改实收金额</h3>
          <button class="close-btn" @click="closeAmountModifyDialog">×</button>
        </div>

        <div class="dialog-content">
          <div class="amount-input-group">
            <label>应收金额：</label>
            <span class="total-amount-display">¥{{ totalAmount.toFixed(2) }}</span>
          </div>

          <div class="amount-input-group">
            <label>实收金额：</label>
            <input
              type="number"
              v-model.number="tempPaidAmount"
              class="amount-dialog-input"
              step="0.01"
              min="0"
              placeholder="请输入实收金额"
            />
            <span class="amount-unit">元</span>
          </div>

          <!-- 抹零原因选择 - 当实收不等于应收时显示 -->
          <div v-if="tempPaidAmount !== totalAmount" class="reason-input-group">
            <label>抹零原因：</label>
            <select
              v-model="tempZeroAmountReason"
              class="reason-dialog-select"
              @change="handleTempReasonChange"
            >
              <option value="">请选择原因</option>
              <option
                v-for="reason in zeroAmountReasons"
                :key="reason.value"
                :value="reason.value"
              >
                {{ reason.label }}
              </option>
            </select>

            <!-- 自定义原因输入框 -->
            <input
              v-if="tempZeroAmountReason === 'other'"
              v-model="tempCustomZeroAmountReason"
              type="text"
              class="custom-reason-dialog-input"
              placeholder="请输入抹零原因"
            />
          </div>
        </div>

        <div class="dialog-footer">
          <button class="cancel-btn" @click="closeAmountModifyDialog">取消</button>
          <button class="confirm-btn" @click="confirmAmountModify">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InventoryView from './Inventory.vue'
import OrdersView from './Orders.vue'
import MembersView from './Members.vue'
import MemberSelector from './MemberSelector.vue'
import TransactionSuccessDialog from './TransactionSuccessDialog.vue'
import { cashierApi } from '../api/cashier.js'
import toast from '../utils/toast.js'

export default {
  name: 'PosSystem',
  components: {
    InventoryView,
    OrdersView,
    MembersView,
    MemberSelector,
    TransactionSuccessDialog
  },
  props: {
    userInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      currentTime: '',
      selectedNav: 'cashier',
      profileInfo: null, // 存储profile接口返回的信息
      searchKeyword: '',
      selectedCategory: 0,
      heldOrders: 6,
      paidAmount: 0.00,
      scanAmount: 0.00,
      categories: [],
      products: [],
      cartItems: [], // 购物车数据结构: [{ product_id: 1, list: [{ is_gift: 0, quantity: 2, price: 10.00 }] }, { product_id: 2, list: [{ is_gift: 1, quantity: 1, price: 0.00 }] }]
      showMemberSelector: false,
      selectedMember: null,
      showOnlyGifts: false, // 控制是否只显示赠品
      isPaidAmountManuallySet: false, // 标记实收金额是否被手动设置
      showZeroAmountReason: false, // 是否显示抹零原因选择
      zeroAmountReason: '', // 选中的抹零原因
      zeroAmountReasons: [ // 预设的抹零原因
        { value: 'packaging_damage', label: '包装破损' },
        { value: 'other', label: '其他' }
      ],
      customZeroAmountReason: '', // 自定义抹零原因

      // 实收金额修改弹窗相关
      showAmountModifyDialog: false, // 是否显示实收金额修改弹窗
      tempPaidAmount: 0, // 临时实收金额
      tempZeroAmountReason: '', // 临时抹零原因
      tempCustomZeroAmountReason: '', // 临时自定义抹零原因

      // 交易成功弹窗相关
      showTransactionSuccess: false, // 是否显示交易成功弹窗
      transactionOrderInfo: {
        orderNo: '',
        amount: 0.00
      }, // 交易订单信息

      // 打印机相关
      selectedPrinter: '', // 当前选择的打印机ID
      availablePrinters: [], // 可用打印机列表（从系统获取）
      isLoadingPrinters: false, // 是否正在加载打印机列表

      // 商品加载状态
      isLoadingProducts: false // 是否正在加载商品列表
    }
  },
  computed: {
    // 显示的用户名，优先使用profile接口返回的信息
    displayName() {
      if (this.profileInfo && this.profileInfo.cashier_info) {
        return this.profileInfo.cashier_info.nickname || this.profileInfo.cashier_info.username
      }
      return this.userInfo.nickname || this.userInfo.username || '收银员'
    },
    // 显示的店铺名，优先使用profile接口返回的信息
    shopName() {
      if (this.profileInfo && this.profileInfo.shop_info) {
        return this.profileInfo.shop_info.name
      }
      return this.userInfo.shopName || '店铺'
    },
    // 检查用户是否有赠品权限
    canGift() {
      if (this.profileInfo && this.profileInfo.cashier_info) {
        return this.profileInfo.cashier_info.can_gift === true
      }
      return false
    },
    // 检查用户是否有零金额收款权限
    canZeroAmount() {
      if (this.profileInfo && this.profileInfo.cashier_info) {
        return this.profileInfo.cashier_info.can_zero_amount === true
      }
      return false
    },
    totalQuantity() {
      let quantity = 0
      this.cartItems.forEach(cartItem => {
        cartItem.list.forEach(itemList => {
          quantity += itemList.quantity
        })
      })
      return quantity
    },
    totalTypes() {
      return this.displayCartItems.length
    },
    totalAmount() {
      let total = 0
      this.cartItems.forEach(cartItem => {
        cartItem.list.forEach(itemList => {
          total += (itemList.price * itemList.quantity)
        })
      })
      return total
    },
    changeAmount() {
      return this.paidAmount - this.totalAmount
    },
    // 判断是否需要显示抹零原因选择
    shouldShowZeroAmountReason() {
      return this.canZeroAmount &&
             this.isPaidAmountManuallySet &&
             this.paidAmount !== this.totalAmount &&
             this.totalAmount > 0
    },
    filteredProducts() {
      let filtered = this.products

      // 按分类筛选 (API返回的分类ID，0表示全部)
      if (this.selectedCategory !== 0) {
        filtered = filtered.filter(p => p.category_id === this.selectedCategory)
      }

      // 按关键词搜索
      if (this.searchKeyword) {
        filtered = filtered.filter(p =>
          p.name.toLowerCase().includes(this.searchKeyword.toLowerCase())
        )
      }

      // 赠品筛选：只显示有赠品库存的商品
      if (this.showOnlyGifts) {
        filtered = filtered.filter(p => p.gift_quantity > 0)
      }

      // 根据赠品权限过滤商品
      filtered = filtered.filter(p => {
        // 如果商品是赠品但用户没有赠品权限，则不显示
        if (p.is_gift && !this.canGift) {
          return false
        }
        return true
      })

      return filtered
    },
    // 转换购物车数据为显示格式
    displayCartItems() {
      const items = []
      this.cartItems.forEach(cartItem => {
        // 获取商品信息
        const product = this.products.find(p => p.id === cartItem.product_id)
        if (product) {
          cartItem.list.forEach(itemList => {
            items.push({
              id: cartItem.product_id,
              name: product.name,
              code: product.code,
              price: itemList.price,
              quantity: itemList.quantity,
              is_gift: itemList.is_gift,
              cartItemKey: `${cartItem.product_id}_${itemList.is_gift}` // 用于唯一标识
            })
          })
        }
      })
      return items
    }
  },
  watch: {
    // 监听应收金额变化，自动更新实收金额
    totalAmount(newAmount) {
      // 如果购物车为空，重置标记和抹零原因
      if (newAmount === 0) {
        this.isPaidAmountManuallySet = false
        this.paidAmount = 0
        this.zeroAmountReason = ''
        this.customZeroAmountReason = ''
        return
      }

      // 无论是否有零金额收款权限，只要用户没有手动修改过实收金额就应该自动更新
      if (!this.isPaidAmountManuallySet) {
        this.paidAmount = newAmount
      }
    }
  },
  methods: {
    // 加载商品分类
    async loadCategories() {
      try {
        const result = await cashierApi.getShopCategories()
        if (result.success && result.data) {
          // 添加"全部"分类到最前面
          this.categories = [
            { id: 0, name: '全部', text: '全' },
            ...result.data.map(cat => ({
              id: parseInt(cat.ID),
              name: cat.title,
              text: cat.title.charAt(0)
            }))
          ]
          console.log('商品分类加载成功:', this.categories)
        } else {
          console.error('获取商品分类失败:', result.message)
        }
      } catch (error) {
        console.error('获取商品分类异常:', error)
      }
    },

    // 加载商品列表
    async loadProducts() {
      try {
        const result = await cashierApi.getShopProducts()
        if (result.success && result.data && result.data.list) {
          this.products = result.data.list.map(item => {
            const product = item.product
            return {
              id: product.ID,
              name: product.name,
              price: product.normal_price,
              member_price: product.member_price,
              quantity: item.quantity, // 正常库存
              gift_quantity: item.gift_quantity || 0, // 赠品库存
              is_gift: item.is_gift === true, // 使用外层的is_gift
              category_id: parseInt(product.category_id),
              category: product.category, // 保存完整的category对象
              category_name: product.category ? product.category.title : '',
              cover_image: product.cover_image, // 添加商品图片
              status: product.status,
              code: product.ID.toString(), // 临时使用ID作为条码
              text: product.name.charAt(0)
            }
          })
          console.log('商品列表加载成功:', this.products)
        } else {
          console.error('获取商品列表失败:', result.message)
        }
      } catch (error) {
        console.error('获取商品列表异常:', error)
      }
    },

    // 根据分类名称获取分类ID
    getCategoryIdByName(categoryName) {
      const category = this.categories.find(cat => cat.name === categoryName)
      return category ? category.id : 0
    },

    // 加载用户详细信息
    async loadProfileInfo() {
      try {
        const result = await cashierApi.getProfile()
        if (result.success) {
          this.profileInfo = result.data
          console.log('用户信息加载成功:', this.profileInfo)
        } else {
          console.error('获取用户信息失败:', result.message)
        }
      } catch (error) {
        console.error('获取用户信息异常:', error)
      }
    },

    updateTime() {
      const now = new Date()
      this.currentTime = now.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      }).replace(/\//g, '/')
    },

    logout() {
      if (confirm('确定要退出登录吗？')) {
        // 清除本地存储
        localStorage.removeItem('isLoggedIn')
        localStorage.removeItem('token')
        localStorage.removeItem('username')
        localStorage.removeItem('nickname')
        localStorage.removeItem('shopId')
        localStorage.removeItem('shopName')

        // 通知父组件退出登录
        this.$emit('logout')

        alert('已退出登录')
      }
    },
    selectNav(navId) {
      this.selectedNav = navId
    },
    increaseQuantity(displayItem) {
      const cartProduct = this.cartItems.find(item => item.product_id === displayItem.id)
      if (cartProduct) {
        const typeItem = cartProduct.list.find(item => item.is_gift === displayItem.is_gift)
        if (typeItem) {
          typeItem.quantity++
        }
      }
    },
    decreaseQuantity(displayItem) {
      const cartProduct = this.cartItems.find(item => item.product_id === displayItem.id)
      if (cartProduct) {
        const typeItem = cartProduct.list.find(item => item.is_gift === displayItem.is_gift)
        if (typeItem) {
          if (typeItem.quantity > 1) {
            typeItem.quantity--
          } else {
            this.removeItem(displayItem)
          }
        }
      }
    },
    removeItem(displayItem) {
      const productIndex = this.cartItems.findIndex(item => item.product_id === displayItem.id)
      if (productIndex > -1) {
        const cartProduct = this.cartItems[productIndex]
        const typeIndex = cartProduct.list.findIndex(item => item.is_gift === displayItem.is_gift)

        if (typeIndex > -1) {
          cartProduct.list.splice(typeIndex, 1)

          // 如果该商品的list为空，移除整个商品项
          if (cartProduct.list.length === 0) {
            this.cartItems.splice(productIndex, 1)
          }
        }
      }
    },

    // 新增方法
    selectCategory(categoryId) {
      this.selectedCategory = parseInt(categoryId)
    },

    handleSearch() {
      // 搜索结果会自动通过filteredProducts计算属性更新
      if (!this.searchKeyword.trim()) {
        alert('请输入搜索关键词')
        return
      }

      const results = this.filteredProducts
      if (results.length === 0) {
        alert('未找到匹配的商品')
      } else {
        alert(`找到 ${results.length} 个商品`)
      }
    },

    validateQuantity(displayItem) {
      // 确保数量是有效的数字
      let quantity = parseInt(displayItem.quantity)

      if (isNaN(quantity) || quantity < 1) {
        quantity = 1
      }

      // 如果数量变为0，移除该商品
      if (quantity === 0) {
        this.removeItem(displayItem)
        return
      }

      // 更新实际购物车数据中的数量
      const cartProduct = this.cartItems.find(item => item.product_id === displayItem.id)
      if (cartProduct) {
        const typeItem = cartProduct.list.find(item => item.is_gift === displayItem.is_gift)
        if (typeItem) {
          typeItem.quantity = quantity
        }
      }
    },

    addToCart(product) {
      // 判断是否为赠品（仅赠品模式下且有赠品库存，或者本身就是赠品）
      const isGiftItem = (this.showOnlyGifts && product.gift_quantity > 0) || product.is_gift
      const isGiftFlag = isGiftItem ? 1 : 0

      // 查找是否已有该商品
      const existingProductItem = this.cartItems.find(item => item.product_id === product.id)

      if (existingProductItem) {
        // 查找该商品是否已有相同类型的（赠品/非赠品）
        const existingType = existingProductItem.list.find(item => item.is_gift === isGiftFlag)

        if (existingType) {
          // 如果已存在相同类型，增加数量
          existingType.quantity++
        } else {
          // 如果不存在相同类型，添加到该商品的list中
          existingProductItem.list.push({
            is_gift: isGiftFlag,
            quantity: 1,
            price: isGiftItem ? 0 : product.price
          })
        }
      } else {
        // 如果商品不存在，创建新的购物车项
        this.cartItems.push({
          product_id: product.id,
          list: [{
            is_gift: isGiftFlag,
            quantity: 1,
            price: isGiftItem ? 0 : product.price
          }]
        })
      }
    },

    // 会员选择相关方法
    openMemberSelector() {
      this.showMemberSelector = true
    },

    closeMemberSelector() {
      this.showMemberSelector = false
    },

    handleMemberSelected(member) {
      this.selectedMember = member
      console.log('已选择会员:', member)
      // 这里可以添加其他处理逻辑，比如应用会员折扣等
    },

    // 处理实收金额输入
    handlePaidAmountInput() {
      this.isPaidAmountManuallySet = true
    },

    // 处理抹零原因变化
    handleReasonChange() {
      // 当选择预设原因时，清空自定义原因
      if (this.zeroAmountReason !== 'other') {
        this.customZeroAmountReason = ''
      }
    },

    // 获取最终抹零原因
    getZeroAmountReasonText() {
      if (this.zeroAmountReason === 'other') {
        return this.customZeroAmountReason
      }
      const reason = this.zeroAmountReasons.find(r => r.value === this.zeroAmountReason)
      return reason ? reason.label : ''
    },

    // 实收金额修改弹窗相关方法
    closeAmountModifyDialog() {
      this.showAmountModifyDialog = false
    },

    // 打开实收金额修改弹窗
    openAmountModifyDialog() {
      this.tempPaidAmount = this.paidAmount
      this.tempZeroAmountReason = this.zeroAmountReason
      this.tempCustomZeroAmountReason = this.customZeroAmountReason
      this.showAmountModifyDialog = true
    },

    // 处理临时抹零原因变化
    handleTempReasonChange() {
      // 当选择预设原因时，清空自定义原因
      if (this.tempZeroAmountReason !== 'other') {
        this.tempCustomZeroAmountReason = ''
      }
    },

    // 确认修改实收金额
    confirmAmountModify() {
      // 验证实收金额
      if (this.tempPaidAmount < 0) {
        toast.error('实收金额不能为负数')
        return
      }

      // 如果实收不等于应收，验证抹零原因
      if (this.tempPaidAmount !== this.totalAmount) {
        if (!this.tempZeroAmountReason) {
          toast.warning('请选择抹零原因')
          return
        }
        if (this.tempZeroAmountReason === 'other' && !this.tempCustomZeroAmountReason.trim()) {
          toast.warning('请输入自定义抹零原因')
          return
        }
      }

      // 应用修改
      this.paidAmount = this.tempPaidAmount
      this.zeroAmountReason = this.tempZeroAmountReason
      this.customZeroAmountReason = this.tempCustomZeroAmountReason
      this.isPaidAmountManuallySet = true

      // 关闭弹窗
      this.closeAmountModifyDialog()
    },

    // 处理结账
    async handleCheckout() {
      // 验证购物车
      if (this.cartItems.length === 0) {
        toast.warning('购物车为空，无法结账')
        return
      }

      // 验证实收金额
      if (this.paidAmount < 0) {
        toast.error('实收金额不能为负数')
        return
      }

      // 验证抹零原因（如果实收金额小于应收金额）
      if (this.paidAmount < this.totalAmount) {
        if (!this.zeroAmountReason) {
          toast.warning('实收金额小于应收金额，请选择抹零原因')
          return
        }
        if (this.zeroAmountReason === 'other' && !this.customZeroAmountReason.trim()) {
          toast.warning('请输入自定义抹零原因')
          return
        }
      }

      // 验证是否选择了会员
      if (!this.selectedMember || !this.selectedMember.id) {
        toast.warning('请选择会员后进行结账')
        return
      }

      // 构建商品数据
      const items = []
      this.cartItems.forEach(cartItem => {
        cartItem.list.forEach(itemList => {
          items.push({
            product_id: cartItem.product_id,
            quantity: itemList.quantity,
            price: itemList.price,
            is_gift: itemList.is_gift
          })
        })
      })

      // 验证商品数据
      for (const item of items) {
        if (!item.product_id || item.quantity <= 0 || item.price < 0) {
          toast.error('商品数据异常，请检查购物车')
          return
        }
      }

      // 构建订单数据
      const orderData = {
        items: items,
        member_id: this.selectedMember.id,
        final_amount: this.paidAmount,
        remark: this.paidAmount < this.totalAmount ? (this.zeroAmountReason === 'other' ? this.customZeroAmountReason : this.getZeroAmountReasonText()) : undefined
      }

      // 获取结账按钮并保存原始文本
      const checkoutButton = document.querySelector('.checkout-button')
      const originalButtonText = checkoutButton?.textContent || '结账'

      try {
        console.log('提交订单数据:', orderData)

        // 显示加载状态
        if (checkoutButton) {
          checkoutButton.textContent = '提交中...'
          checkoutButton.disabled = true
        }

        // 使用真实的API调用创建订单
        const response = await fetch('http://erpvue.geslan.cn/erp/cashier/order/create', {
          method: 'POST',
          headers: {
            'Accept': '*/*',
            'Accept-Language': 'zh-CN',
            'Connection': 'keep-alive',
            'Content-Type': 'application/json',
            'Origin': 'http://localhost:8080',
            'Referer': 'http://localhost:8080/',
            'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) rui-mu-tong-pos-system/0.1.0 Chrome/124.0.6367.243 Electron/30.5.1 Safari/537.36',
            'X-Request-Time': Date.now().toString(),
            'x-token': localStorage.getItem('token') || ''
          },
          body: JSON.stringify(orderData)
        })

        const result = await response.json()

        if (result.code === 0 && result.data) {
          // 显示交易成功弹窗，使用真实的订单数据
          this.transactionOrderInfo = {
            orderNo: result.data.order_no || 'N/A',
            amount: result.data.final_amount || this.paidAmount,
            orderData: result.data // 保存完整的订单数据用于打印
          }
          this.showTransactionSuccess = true

          // 清空购物车和相关状态
          this.cartItems = []
          this.selectedMember = null
          this.paidAmount = 0.00
          this.isPaidAmountManuallySet = false
          this.zeroAmountReason = ''
          this.customZeroAmountReason = ''

          console.log('订单创建成功，订单号:', result.data.order_no)
          console.log('订单数据:', result.data)

          // 重新获取商品列表以更新库存
          this.loadProducts()
        } else {
          const errorMsg = result.msg || '未知错误'
          console.error('订单创建失败:', result)
          toast.error(`交易失败：${errorMsg}`)
        }
      } catch (error) {
        console.error('订单创建异常:', error)

        // 根据错误类型显示不同提示
        let errorMessage = '订单创建异常，请稍后重试'
        if (error.message.includes('Network')) {
          errorMessage = '网络连接异常，请检查网络后重试'
        } else if (error.message.includes('timeout')) {
          errorMessage = '请求超时，请稍后重试'
        } else if (error.response) {
          errorMessage = `服务器错误：${error.response.status} ${error.response.statusText || ''}`
        }

        toast.error(errorMessage)
      } finally {
        // 恢复按钮状态
        if (checkoutButton) {
          checkoutButton.textContent = originalButtonText
          checkoutButton.disabled = false
        }
      }
    },

    // 处理交易成功弹窗确认
    handleTransactionConfirm() {
      this.showTransactionSuccess = false
    },

    // 处理打印小票
    handlePrintReceipt() {
      // 这里实现打印小票的逻辑
      console.log('打印小票，订单号:', this.transactionOrderInfo.orderNo)
      console.log('使用打印机:', this.selectedPrinter)

      if (!this.selectedPrinter) {
        toast.warning('请先选择打印机')
        return
      }

      // 打印逻辑
      this.printOrder(this.transactionOrderInfo.orderNo)
    },

    // 处理打印机选择变化
    handlePrinterChange() {
      console.log('打印机选择已更改为:', this.selectedPrinter)
      console.log('可用打印机列表:', this.availablePrinters)
      // 保存选择到本地存储
      localStorage.setItem('selectedPrinter', this.selectedPrinter)

      const selectedPrinterName = this.availablePrinters.find(p => p.id === this.selectedPrinter)?.name || '未知打印机'
      console.log('选中的打印机名称:', selectedPrinterName)
      toast.success(`已切换到 ${selectedPrinterName}`)
    },

    // 打印订单小票
    async printOrder(orderNo) {
      try {
        console.log(`开始打印订单 ${orderNo} 到打印机 ${this.selectedPrinter}`)
        toast.info('正在生成小票...')

        // 生成小票内容
        const receiptData = await this.generateReceiptData(orderNo)

        toast.info('正在打印小票...')

        // 调用打印API
        if (window.electronAPI && typeof window.electronAPI.printDocument === 'function') {
          // 使用Electron打印API
          const result = await window.electronAPI.printDocument({
            printerName: this.selectedPrinter,
            documentData: receiptData,
            documentName: `小票_${orderNo}`
          })

          if (result.success) {
            toast.success('小票打印成功')
          } else {
            throw new Error(result.error || '打印失败')
          }
        } else {
          // Web环境或降级方案 - 模拟打印
          setTimeout(() => {
            toast.success('小票打印成功（模拟）')
          }, 2000)
        }

      } catch (error) {
        console.error('打印失败:', error)
        toast.error(`打印失败：${error.message}`)
      }
    },

    // 生成小票数据
    async generateReceiptData(orderNo) {
      const now = new Date()
      const dateStr = now.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })

      // 获取选中打印机的信息
      const printer = this.availablePrinters.find(p => p.id === this.selectedPrinter)
      const printerName = printer ? printer.name : '未知打印机'

      // 获取订单数据
      const orderData = this.transactionOrderInfo.orderData

      // 使用真实订单数据或购物车数据
      let items = []
      if (orderData && orderData.items) {
        // 使用服务器返回的真实订单数据
        items = orderData.items.map(item => ({
          name: item.productName || item.product?.name || '商品',
          quantity: item.quantity,
          price: item.unitPrice ? item.unitPrice.toFixed(2) : '0.00',
          subtotal: item.subtotal ? item.subtotal.toFixed(2) : (item.quantity * (item.unitPrice || 0)).toFixed(2),
          isGift: item.isGift
        }))
      } else {
        // 降级使用购物车数据
        items = this.displayCartItems.map(item => ({
          name: item.name,
          quantity: item.quantity,
          price: item.price.toFixed(2),
          subtotal: (item.price * item.quantity).toFixed(2),
          isGift: item.is_gift === 1
        }))
      }

      // 构建小票内容
      const receipt = {
        header: {
          shopName: this.shopName || '瑞牧通收银系统',
          title: '销售小票',
          orderNo: orderNo,
          date: dateStr,
          cashier: this.displayName
        },
        items: items,
        summary: {
          totalAmount: orderData ? (orderData.total_amount || orderData.final_amount || 0).toFixed(2) : this.totalAmount.toFixed(2),
          paidAmount: orderData ? (orderData.final_amount || 0).toFixed(2) : this.paidAmount.toFixed(2),
          change: '0.00', // 实际支付中通常没有找零
          paymentMethod: '现金',
          memberInfo: this.selectedMember ? `会员: ${this.selectedMember.name}` : '非会员'
        },
        footer: {
          printer: printerName,
          message: '谢谢惠顾，欢迎再次光临！'
        }
      }

      return receipt
    },

    // 获取系统打印机列表
    async loadPrinters() {
      this.isLoadingPrinters = true
      try {
        console.log('检查Electron环境...')
        console.log('window.electronAPI:', window.electronAPI)
        console.log('window.ipcRenderer:', window.ipcRenderer)

        // 检查是否在Electron环境中
        const electronAPI = window.electronAPI
        if (electronAPI && typeof electronAPI.getPrinters === 'function') {
          // 使用Electron API获取打印机列表
          try {
            const printers = await electronAPI.getPrinters()
            this.availablePrinters = printers.map(printer => ({
              id: printer.id || printer.name,
              name: printer.displayName || printer.name,
              isDefault: printer.isDefault || false
            }))
          } catch (apiError) {
            console.warn('Electron API调用失败，使用备用方案:', apiError)
            this.availablePrinters = await this.getWebPrinters()
          }
        } else {
          // Web环境或Electron API不可用，使用模拟数据
          console.warn('Electron API不可用，使用模拟数据')
          this.availablePrinters = await this.getWebPrinters()
        }
        console.log('获取到打印机列表:', this.availablePrinters)

        // 从本地存储恢复上一次的选择（优先级最高）
        const savedPrinter = localStorage.getItem('selectedPrinter')
        if (savedPrinter && this.availablePrinters.find(p => p.id === savedPrinter)) {
          this.selectedPrinter = savedPrinter
        } else {
          // 如果没有保存的选择，选择默认打印机
          const defaultPrinter = this.availablePrinters.find(p => p.isDefault)
          if (defaultPrinter) {
            this.selectedPrinter = defaultPrinter.id
          } else if (this.availablePrinters.length > 0) {
            // 如果没有默认打印机，选择第一个
            this.selectedPrinter = this.availablePrinters[0].id
          }
        }

      } catch (error) {
        console.error('获取打印机列表失败:', error)
        toast.error('获取打印机列表失败')
        // 设置默认打印机列表
        this.availablePrinters = [
          { id: 'default', name: '默认打印机', isDefault: true }
        ]
      } finally {
        this.isLoadingPrinters = false
      }
    },

    // Web环境下的打印机获取（从后端API或使用模拟数据）
    async getWebPrinters() {
      try {
        // 首先尝试从后端API获取打印机列表
        // const result = await cashierApi.getPrinters()
        // if (result.success && result.data) {
        //   return result.data.map(printer => ({
        //     id: printer.id,
        //     name: printer.name,
        //     isDefault: printer.isDefault
        //   }))
        // }

        // 如果没有API或API失败，使用模拟数据
        return new Promise((resolve) => {
          setTimeout(() => {
            // 尝试从localStorage获取缓存的打印机列表
            const cachedPrinters = localStorage.getItem('cachedPrinters')
            if (cachedPrinters) {
              try {
                resolve(JSON.parse(cachedPrinters))
                return
              } catch (e) {
                console.warn('解析缓存的打印机列表失败:', e)
              }
            }

            // 默认模拟数据
            const printers = [
              { id: 'web_printer1', name: '系统默认打印机', isDefault: true },
              { id: 'web_printer2', name: 'PDF虚拟打印机', isDefault: false },
              { id: 'web_printer3', name: 'Microsoft Print to PDF', isDefault: false }
            ]

            // 缓存打印机列表
            localStorage.setItem('cachedPrinters', JSON.stringify(printers))
            resolve(printers)
          }, 300)
        })
      } catch (error) {
        console.error('获取Web打印机列表失败:', error)
        // 返回最基本的选项
        return [{ id: 'fallback', name: '默认打印机', isDefault: true }]
      }
    },

    // 初始化打印机选择
    async initializePrinter() {
      await this.loadPrinters()
    },

    // 刷新打印机列表
    async refreshPrinters() {
      console.log('刷新打印机列表...')
      await this.loadPrinters()
      toast.success('打印机列表已刷新')
    },

    // 刷新商品列表
    async refreshProducts() {
      console.log('刷新商品列表...')
      this.isLoadingProducts = true
      try {
        // 同时刷新分类和商品
        await Promise.all([
          this.loadCategories(),
          this.loadProducts()
        ])
        toast.success('商品列表已刷新')
      } catch (error) {
        console.error('刷新商品列表失败:', error)
        toast.error('刷新商品列表失败')
      } finally {
        this.isLoadingProducts = false
      }
    },
  },
  mounted() {
    this.updateTime()
    setInterval(this.updateTime, 60000) // 每分钟更新一次时间
    this.loadProfileInfo() // 加载用户详细信息
    this.initializePrinter() // 初始化打印机选择

    // 先加载分类，再加载商品
    this.loadCategories().then(() => {
      this.loadProducts()
    })
  },
}
</script>

<style scoped>
.pos-layout {
  display: flex;
  height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  font-family: 'Microsoft YaHei', -apple-system, BlinkMacSystemFont, sans-serif;
}

.pos-layout.inventory-mode {
  display: flex;
}

/* 左侧导航区 */
.sidebar {
  flex: 0 0 15%;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-right: 1px solid rgba(255, 255, 255, 0.3);
  display: flex;
  flex-direction: column;
  min-width: 0;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}

.sidebar-header {
  padding: 28px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  text-align: center;
  background: rgba(248, 250, 252, 0.8);
}

.printer-selector {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.printer-selector:hover {
  background: rgba(255, 255, 255, 0.8);
  border-color: rgba(102, 126, 234, 0.2);
}

.printer-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  color: #374151;
  min-width: 0;
  flex-shrink: 0;
}

.printer-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
  opacity: 0.7;
  transition: all 0.3s ease;
}

.printer-selector:hover .printer-icon {
  opacity: 1;
  transform: scale(1.1);
}

.printer-select {
  flex: 1;
  min-width: 0;
  padding: 6px 10px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 11px;
  background: white;
  color: #374151;
  outline: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.printer-select:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.printer-select:hover {
  border-color: #9ca3af;
}

.refresh-printers-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: white;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  padding: 0;
  flex-shrink: 0;
}

.refresh-printers-btn:hover:not(:disabled) {
  border-color: #667eea;
  background: rgba(102, 126, 234, 0.1);
  transform: scale(1.05);
}

.refresh-printers-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.refresh-icon {
  width: 14px;
  height: 14px;
  object-fit: contain;
  opacity: 0.7;
  transition: all 0.3s ease;
}

.refresh-printers-btn:hover:not(:disabled) .refresh-icon {
  opacity: 1;
}

.refresh-icon.spinning {
  animation: spin 1s linear infinite;
}


@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.login-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.user-info {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a2e;
  display: flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.shop-info {
  font-size: 14px;
  color: #64748b;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
}

.info-icon {
  width: 18px;
  height: 18px;
  object-fit: contain;
  opacity: 0.8;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.user-info:hover .info-icon,
.shop-info:hover .info-icon {
  opacity: 1;
  transform: scale(1.1);
}

.nav-buttons {
  flex: 1;
  padding: 24px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.nav-item {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 16px;
  font-weight: 600;
  color: #374151;
  background: transparent;
  border: 2px solid transparent;
  position: relative;
  overflow: hidden;
}

.nav-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #667eea, #764ba2);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.nav-item:hover {
  background: rgba(102, 126, 234, 0.1);
  border-color: rgba(102, 126, 234, 0.2);
  transform: translateX(4px);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.1);
}

.nav-item.active {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border-color: transparent;
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
  transform: scale(1.02);
}

.nav-icon {
  width: 24px;
  height: 24px;
  margin-right: 12px;
  object-fit: contain;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  filter: brightness(0) saturate(100%) invert(46%) sepia(79%) saturate(374%) hue-rotate(182deg) brightness(90%) contrast(85%);
  opacity: 0.7;
}

.nav-icon-text {
  width: 28px;
  height: 28px;
  margin-right: 12px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.nav-item:hover .nav-icon {
  transform: scale(1.1);
  filter: brightness(0) saturate(100%) invert(46%) sepia(79%) saturate(374%) hue-rotate(182deg) brightness(100%) contrast(100%);
  opacity: 1;
}

.nav-item.active .nav-icon {
  filter: brightness(0) invert(1);
  transform: scale(1.1);
  opacity: 1;
}

.nav-text {
  font-size: 14px;
  letter-spacing: 0.3px;
}

/* 中间商品清单区 */
.product-list {
  width: 60%;
  background-color: white;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e8e8e8;
}

.section-title {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  padding: 20px;
  border-bottom: 2px solid #f0f0f0;
  color: #2c3e50;
}

.list-header {
  display: grid;
  grid-template-columns: 3fr 1fr 1fr 1fr 1fr 1fr;
  background-color: #fafafa;
  padding: 15px;
  border-bottom: 1px solid #e8e8e8;
  font-weight: bold;
  font-size: 14px;
  color: #666;
}

.product-row {
  display: grid;
  grid-template-columns: 3fr 1fr 1fr 1fr 1fr 1fr;
  padding: 15px;
  border-bottom: 1px solid #f0f0f0;
  align-items: center;
}

.product-row:hover {
  background-color: #f9f9f9;
}

.product-name {
  font-weight: 500;
  margin-bottom: 3px;
}

.product-code {
  font-size: 12px;
  color: #999;
}

.col-price, .col-member-price, .col-subtotal {
  text-align: center;
}

.quantity-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
}

.quantity {
  min-width: 30px;
  text-align: center;
  font-weight: 500;
}

.col-actions {
  text-align: center;
}

.bottom-actions {
  margin-top: auto;
  padding: 20px;
  background-color: #fafafa;
  border-top: 1px solid #e8e8e8;
  display: flex;
  align-items: center;
  gap: 20px;
}

.stats-section {
  color: #666;
  font-size: 14px;
}

.action-buttons {
  margin-left: auto;
  display: flex;
  gap: 10px;
}

/* 右侧结算操作区 */
.checkout-panel {
  flex: 0 0 25%;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-left: 1px solid rgba(255, 255, 255, 0.3);
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}

.member-section {
  flex-shrink: 0;
}

.member-button {
  width: 100%;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border: none;
  height: 40px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.member-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.cart-list {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(20px);
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08);
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 320px;
}

.cart-title {
  margin: 0 0 12px 0;
  font-size: 16px;
  font-weight: 700;
  color: #1a1a2e;
  background: linear-gradient(135deg, #667eea, #764ba2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  padding-bottom: 10px;
  border-bottom: 2px solid rgba(102, 126, 234, 0.1);
  flex-shrink: 0;
  position: relative;
}

.cart-title::before {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 40px;
  height: 2px;
  background: linear-gradient(90deg, #667eea, #764ba2);
}

.cart-items {
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  flex: 1;
  padding-right: 4px;
}

.checkout-bottom {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex-shrink: 0;
}

.cart-empty {
  text-align: center;
  color: #94a3b8;
  padding: 24px 16px;
  font-size: 14px;
  font-weight: 600;
  background: rgba(248, 250, 252, 0.6);
  border-radius: 12px;
  border: 2px dashed rgba(102, 126, 234, 0.2);
}

.cart-item {
  padding: 12px;
  background: rgba(248, 250, 252, 0.8);
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-radius: 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.cart-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #667eea, #764ba2);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.cart-item:hover {
  background: rgba(102, 126, 234, 0.05);
  border-color: rgba(102, 126, 234, 0.2);
  transform: translateX(4px);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.1);
}

.cart-item:hover::before {
  opacity: 1;
}

.cart-item-main {
  margin-bottom: 8px;
}

.cart-item-name {
  font-size: 13px;
  font-weight: 600;
  color: #1a1a2e;
  line-height: 1.3;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.cart-item-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}

.cart-item-price {
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
  min-width: 40px;
  flex-shrink: 0;
}

.cart-item-subtotal {
  color: #e74c3c;
  font-weight: 700;
  font-size: 13px;
  min-width: 50px;
  text-align: right;
  flex-shrink: 0;
  background: linear-gradient(135deg, #e74c3c, #c0392b);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.cart-item-quantity {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.quantity-btn {
  width: 28px;
  height: 28px;
  border: 2px solid #e5e7eb;
  background: white;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  color: #374151;
}

.quantity-btn:hover {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border-color: transparent;
  transform: scale(1.05);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.quantity-btn:active {
  transform: scale(0.95);
}

.quantity-input {
  width: 48px;
  height: 28px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  text-align: center;
  font-weight: 700;
  font-size: 13px;
  color: #374151;
  background: white;
  outline: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.quantity-input:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.quantity {
  min-width: 24px;
  text-align: center;
  font-weight: 600;
  font-size: 14px;
  color: #333;
}

.amount-display {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(20px);
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08);
}

.payment-top-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.total-amount {
  font-size: 16px;
  color: #1a1a2e;
  font-weight: 600;
}

.zero-amount {
  font-size: 14px;
  color: #1a1a2e;
  font-weight: 600;
}

.zero-amount .amount {
  color: #52c41a;
  font-weight: bold;
}

.total-amount .amount {
  font-size: 26px;
  font-weight: 900;
  background: linear-gradient(135deg, #667eea, #764ba2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.actual-amount-input {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 10px 0;
  padding: 8px;
  background-color: #f9f9f9;
  border-radius: 4px;
  border: 1px solid #e8e8e8;
  width: 100%;
  box-sizing: border-box;
}

.actual-amount-input label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  min-width: 40px;
  flex-shrink: 0;
}

.amount-input-field {
  flex: 1;
  height: 28px;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  padding: 0 8px;
  font-size: 14px;
  font-weight: bold;
  color: #1890ff;
  background-color: white;
  outline: none;
  transition: all 0.2s;
  min-width: 0;
  box-sizing: border-box;
}

.amount-input-field:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24,144,255,0.2);
}

.amount-unit {
  font-size: 14px;
  color: #666;
  min-width: 20px;
  flex-shrink: 0;
}

.zero-amount-reason {
  margin: 10px 0;
  padding: 8px;
  background-color: #fff7e6;
  border: 1px solid #ffd591;
  border-radius: 4px;
}

.reason-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.reason-label {
  font-size: 12px;
  font-weight: 500;
  color: #d46b08;
  min-width: 60px;
  flex-shrink: 0;
}

.reason-select-compact {
  flex: 1;
  min-width: 0;
  height: 28px;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  padding: 0 6px;
  font-size: 12px;
  background-color: white;
  outline: none;
  transition: all 0.2s;
  box-sizing: border-box;
}

.reason-select-compact:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 1px rgba(24,144,255,0.2);
}

.custom-reason-input-compact {
  flex: 1;
  min-width: 0;
  height: 28px;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  padding: 0 6px;
  font-size: 12px;
  background-color: white;
  outline: none;
  transition: all 0.2s;
  box-sizing: border-box;
}

.custom-reason-input-compact:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 1px rgba(24,144,255,0.2);
}

.payment-details {
  border-top: 2px solid rgba(102, 126, 234, 0.1);
  padding-top: 16px;
}

.payment-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-size: 14px;
}

.payment-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  font-weight: 600;
  color: #374151;
}

.payment-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.payment-row .amount {
  font-weight: 700;
  color: #1a1a2e;
  min-width: 80px;
  text-align: right;
  font-size: 15px;
}

.modify-amount-btn {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1));
  border: 2px solid rgba(102, 126, 234, 0.2);
  color: #667eea;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  padding: 4px 10px;
  border-radius: 8px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.modify-amount-btn:hover {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border-color: transparent;
  transform: translateY(-1px);
}

.checkout-action {
  margin-top: 4px;
}

.checkout-button {
  width: 100%;
  height: 48px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border: none;
  border-radius: 16px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.3);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  position: relative;
  overflow: hidden;
}

.checkout-button::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

.checkout-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 35px rgba(102, 126, 234, 0.4);
}

.checkout-button:active::before {
  width: 400px;
  height: 400px;
}

/* 实收金额修改弹窗样式 */
.amount-modify-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.amount-modify-dialog {
  background-color: white;
  border-radius: 8px;
  width: 400px;
  max-width: 90vw;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
}

.dialog-header h3 {
  margin: 0;
  font-size: 16px;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 20px;
  color: #999;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s;
}

.close-btn:hover {
  background-color: #f5f5f5;
  color: #666;
}

.dialog-content {
  padding: 20px;
}

.amount-input-group {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.amount-input-group label {
  min-width: 80px;
  font-size: 14px;
  color: #333;
}

.total-amount-display {
  font-size: 16px;
  font-weight: bold;
  color: #1890ff;
}

.amount-dialog-input {
  flex: 1;
  height: 36px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 0 12px;
  font-size: 14px;
  background-color: white;
  outline: none;
  transition: all 0.2s;
}

.amount-dialog-input:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24,144,255,0.2);
}

.reason-input-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.reason-input-group label {
  font-size: 14px;
  color: #333;
  margin-bottom: 4px;
}

.reason-dialog-select {
  width: 100%;
  height: 32px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 0 8px;
  font-size: 14px;
  background-color: white;
  outline: none;
  transition: all 0.2s;
}

.reason-dialog-select:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24,144,255,0.2);
}

.custom-reason-dialog-input {
  width: 100%;
  height: 32px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 0 8px;
  font-size: 14px;
  background-color: white;
  outline: none;
  transition: all 0.2s;
  margin-top: 8px;
}

.custom-reason-dialog-input:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24,144,255,0.2);
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid #f0f0f0;
}

.cancel-btn {
  background-color: white;
  color: #666;
  border: 1px solid #d9d9d9;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
}

.cancel-btn:hover {
  border-color: #4096ff;
  color: #4096ff;
}

.confirm-btn {
  background-color: #1890ff;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
}

.confirm-btn:hover {
  background-color: #4096ff;
}

/* 商品选择区域样式 */
.product-selection {
  flex: 1;
  height: 100vh;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  display: flex;
  flex-direction: column;
  border-right: 1px solid rgba(255, 255, 255, 0.3);
  min-width: 0;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 28px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  background: rgba(248, 250, 252, 0.8);
  flex-shrink: 0;
  min-height: 80px;
  position: relative;
  z-index: 10;
}

.section-title {
  margin: 0;
  font-size: 24px;
  font-weight: 800;
  color: #1a1a2e;
  background: linear-gradient(135deg, #667eea, #764ba2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -0.5px;
  position: relative;
  padding-left: 20px;
}

.section-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 24px;
  background: linear-gradient(180deg, #667eea, #764ba2);
  border-radius: 2px;
}

.search-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  position: relative;
  z-index: 11;
}

.search-input {
  background: white;
  border: 2px solid #e5e7eb;
  height: 44px;
  padding: 0 16px;
  border-radius: 16px;
  font-size: 14px;
  width: 320px;
  outline: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  color: #374151;
  font-weight: 500;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.search-input:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  transform: translateY(-1px);
}

.search-input::placeholder {
  color: #94a3b8;
}

.search-button {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border: none;
  height: 44px;
  padding: 0 24px;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  min-width: 100px;
  white-space: nowrap;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.search-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
}

.refresh-products-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  background: linear-gradient(135deg, #52c41a, #389e0d);
  border: none;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 15px rgba(82, 196, 26, 0.3);
  padding: 0;
  flex-shrink: 0;
}

.refresh-products-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(82, 196, 26, 0.4);
}

.refresh-products-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.refresh-products-btn .refresh-icon {
  width: 18px;
  height: 18px;
  object-fit: contain;
  filter: brightness(0) invert(1);
  opacity: 0.9;
  transition: all 0.3s ease;
}

.refresh-products-btn:hover:not(:disabled) .refresh-icon {
  opacity: 1;
}

.category-tabs {
  display: flex;
  padding: 20px 28px;
  gap: 12px;
  background: rgba(255, 255, 255, 0.6);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  overflow-x: auto;
}

.category-tab {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  border: 2px solid #e5e7eb;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  background: white;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  min-width: 90px;
  color: #374151;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.category-tab:hover {
  border-color: #667eea;
  color: #667eea;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.15);
}

.category-tab.active {
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-color: transparent;
  color: white;
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
  transform: scale(1.05);
}

.category-name {
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.3px;
}

/* 赠品筛选样式 */
.gift-filter-tab {
  margin-left: auto;
  flex-shrink: 0;
}

.gift-filter-label {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border: 2px solid #e5e7eb;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  background: white;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  min-width: 90px;
  justify-content: center;
  color: #374151;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.gift-filter-label:hover {
  border-color: #52c41a;
  color: #52c41a;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(82, 196, 26, 0.15);
}

.gift-filter-checkbox {
  accent-color: #52c41a;
  cursor: pointer;
  width: 16px;
  height: 16px;
}

.products-grid {
  flex: 1;
  padding: 28px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 20px;
  overflow-y: auto;
  min-height: 0;
}

.product-card {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(20px);
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-radius: 20px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  height: 200px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
}

 

.product-card:hover {
  transform: translateY(-6px) scale(1.02);
  box-shadow: 0 20px 60px rgba(102, 126, 234, 0.15);
  border-color: rgba(102, 126, 234, 0.3);
}

.product-card:hover::before {
  opacity: 1;
}

.product-image {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  background: rgba(248, 250, 252, 0.8);
  border-radius: 16px;
  overflow: hidden;
  border: 2px solid rgba(0, 0, 0, 0.05);
  flex-shrink: 0;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-info {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-height: 0;
}

.product-name {
  font-size: 13px;
  font-weight: 600;
  color: #1a1a2e;
  line-height: 1.2;
  margin-bottom: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  flex-shrink: 0;
}

.product-stock {
  font-size: 11px;
  color: #64748b;
  margin-bottom: 2px;
  font-weight: 500;
  flex-shrink: 0;
}

.product-category {
  position: absolute;
  top: 8px;
  left: 8px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  font-size: 9px;
  padding: 2px 6px;
  border-radius: 8px;
  font-weight: 700;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.4);
  z-index: 2;
  max-width: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.product-price {
  font-size: 16px;
  font-weight: 800;
  color: #e74c3c;
  background: linear-gradient(135deg, #e74c3c, #c0392b);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-top: auto;
  flex-shrink: 0;
}

.gift-price {
  color: #52c41a;
  font-size: 14px;
  font-weight: 700;
  background: linear-gradient(135deg, #52c41a, #389e0d);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.add-button {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: bold;
  opacity: 0;
  transform: scale(0.8);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.product-card:hover .add-button {
  opacity: 1;
  transform: scale(1);
}

.product-card:hover .add-button:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}



/* 修改中间区域的宽度适配 */
.pos-layout {
  display: flex;
  height: 100vh;
  background-color: #f5f5f5;
  font-family: 'Microsoft YaHei', sans-serif;
}
</style>